export enum UserType {
	NonAdministrator = '0',
	Administrator = '1',
}
